import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import classnames from "classnames";
import { update_zendesk_form } from "../../reducers/Feedback/reducer.js";
import feedbackButton from "./styles/themes/feedbackButton.module.scss";

type FeedbackButtonProps = {
    formName: string;
    children: React.ReactNode;
    classNames?: string | string[];
};

/**
 * A button to open a Zendesk feedback form.
 */
export const FeedbackButton = ({
    formName,
    children,
    classNames,
}: FeedbackButtonProps) => {
    const dispatch = useDispatch();
    const [buttonId, setButtonId] = useState("");

    useEffect(() => {
        const randomId = Math.floor(Math.random() * 10000);
        setButtonId(`feedbackButton-${randomId}`);
    }, []);

    const handleClick = () => {
        //Dispatch Zendesk Update
        dispatch(update_zendesk_form({ formName, buttonId }));
    };

    return (
        <button
            className={classnames(classNames, feedbackButton.feedbackButton)}
            onClick={handleClick}
            id={buttonId}
        >
            {children}
        </button>
    );
};

export default FeedbackButton;
